module.exports = __webpack_public_path__ + "static/media/BoxSlope.30b2ad52.svg";